<template>
  <div>
    <el-row :gutter="6">
      <el-col :sm="10" class="right">
        {{ $t(labelKey) }}
      </el-col>
      <el-col :sm="10" class="right">
        <el-tooltip placement="top">
          <div slot="content">
            {{ minutes }} {{ $t('api.minutes') }}
          </div>
          <span>{{ getTextByMinutes(minutes) }}</span>
        </el-tooltip>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { getTextByMinutes } from '@/utils/time'

export default {
  name: 'duration-field',
  props: {
    labelKey: {
      type: String,
      required: true
    },
    minutes: {
      type: Number,
      required: true
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    getTextByMinutes
  }
}
</script>
